// extracted by mini-css-extract-plugin
module.exports = {"preHeader":"Header_preHeader__1tqdn"};